import { useState, useEffect, useRef } from 'react';
import { Tooltip } from '@mui/material';
import { ReactComponent as HelpIcon } from '../../icons/tooltip.svg';
import { CMTooltip } from './help-tooltip.styles';

const HelpTooltip = ({ title }) => {
  const [open, setOpen] = useState(false);
  const iconRef = useRef(null);

  const handleClick = (e) => {
    e.stopPropagation();
    setOpen((prev) => !prev);
  };

  const handleMouseEnter = () => {
    setOpen(true);
  };

  const handleMouseLeave = () => {
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (iconRef.current && !iconRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <CMTooltip className="tooltip">
      <Tooltip
        title={title}
        open={open}
        disableFocusListener
        disableTouchListener
        componentsProps={{
          tooltip: {
          sx: {
            fontSize: '1rem',
            padding: '8px 12px',
            maxWidth: '500px', 
            '@media (min-width:2000px)': {
              fontSize: '2vh', 
              maxWidth: 'none', 
              },
          },
    },
        }}
      >
        <span
          ref={iconRef}
          onClick={handleClick}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          style={{ cursor: 'pointer', display: 'inline-block',backgroundColor:"white"}}
        >
          <HelpIcon width={16.45} height={16.45} />
        </span>
      </Tooltip>
    </CMTooltip>
  );
};

export default HelpTooltip;
